import { lazy, ReactNode, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loadable from "../components/Loadable";
import GeneralLayout from "../layouts/generalLayout/GeneralLayout";
import GeneralLayoutAlt from "../layouts/generalLayoutAlt/GeneralLayoutAlt";
import {
  IAuthState,
  resetLoggedOut,
} from "../stateManagement/reducers/authReducer";
import { IRootReducerT } from "../stateManagement/reduxStore";

const LLandingPage = Loadable(
  lazy(() => import("../pages/LandingPage/LandingPage")),
);

const LVision = Loadable(lazy(() => import("../pages/Vision/Vision")));
const LOurTeam = Loadable(lazy(() => import("../pages/OurTeam/OurTeam")));
const LContactUs = Loadable(lazy(() => import("../pages/ContactUs/ContactUs")));

const LTestimonials = Loadable(
  lazy(() => import("../pages/Testimonials/Testimonials")),
);

const LConsultancy = Loadable(
  lazy(() => import("../pages/Consultancy/Consultancy")),
);
const LRegulatory = Loadable(
  lazy(() => import("../pages/Regulatory/Regulatory")),
);
const LInvestmentOpportunity = Loadable(
  lazy(() => import("../pages/InvestmentOpportunity/InvestmentOpportunity")),
);
const LWorkshops = Loadable(lazy(() => import("../pages/Workshops/Workshops")));
const LRecruitment = Loadable(
  lazy(() => import("../pages/Recruitment/Recruitment")),
);
const LSourcing = Loadable(lazy(() => import("../pages/Sourcing/Sourcing")));
const LFinancing = Loadable(lazy(() => import("../pages/Financing/Financing")));
const LAdvertiseYourBusiness = Loadable(
  lazy(() => import("../pages/AdvertiseYourBusiness/AdvertiseYourBusiness")),
);
const LOtherServices2 = Loadable(
  lazy(() => import("../pages/OtherServices2/OtherServices2")),
);

const LMemberships = Loadable(
  lazy(() => import("../pages/Memberships/Memberships")),
);

const LFAQ = Loadable(lazy(() => import("../pages/FAQ/FAQ")));
const LTermsAndConditions = Loadable(
  lazy(() => import("../pages/TermsAndConditions/TermsAndConditions")),
);

const LRecordedClips = Loadable(
  lazy(() => import("../pages/RecordedClips/RecordedClips")),
);
const LGallery = Loadable(lazy(() => import("../pages/Gallery/Gallery")));

const LPaymentConfirmation = Loadable(
  lazy(() => import("../pages/PaymentConfirmation/PaymentConfirmation")),
);
const LPaymentAbortion = Loadable(
  lazy(() => import("../pages/PaymentAbortion/PaymentAbortion")),
);

const LOtherServices = Loadable(
  lazy(() => import("../pages/OtherServices/OtherServices")),
);

const LCustomerProducts = Loadable(
  lazy(() => import("../pages/CustomerProducts/CustomerProducts")),
);

const LResourceHub = Loadable(
  lazy(() => import("../pages/ResourceHub/ResourceHub")),
);

interface IPageTemplateProps {
  altRoute: string;
  page: ReactNode;
  pageName: string;
}

const PageTemplate: React.FC<IPageTemplateProps> = ({
  pageName,
  altRoute,
  page,
}) => {
  const dispatch = useDispatch<any>();
  const { authToken, user, loggedOut } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );

  const [isInitRender120, setIsInitRender120] = useState(true);
  useEffect(() => {
    if (isInitRender120) {
      setIsInitRender120(false);
      dispatch(resetLoggedOut({ authToken: authToken ?? "" }));
      return;
    }

    if (!authToken) {
      window.open("/", "_self");
    }
  }, [loggedOut]);

  return <>{page}</>;
};

const NoAuthRoutes = {
  path: "/",
  element: <PageTemplate pageName="" altRoute="" page={<GeneralLayout />} />,
  children: [
    {
      path: "welcome",
      element: <LLandingPage />,
    },
    {
      path: "about/vision",
      element: <LVision />,
    },
    {
      path: "about/our-team",
      element: <LOurTeam />,
    },
    {
      path: "about/contact-us",
      element: <LContactUs />,
    },
    {
      path: "testimonials",
      element: <LTestimonials />,
    },
    {
      path: "services/consultancy",
      element: <LConsultancy />,
    },
    {
      path: "services/regulatory",
      element: <LRegulatory />,
    },
    {
      path: "services/investment-opportunity",
      element: <LInvestmentOpportunity />,
    },
    {
      path: "services/workshops",
      element: <LWorkshops />,
    },
    {
      path: "services/recruitment",
      element: <LRecruitment />,
    },
    {
      path: "services/sourcing",
      element: <LSourcing />,
    },
    {
      path: "services/financing",
      element: <LFinancing />,
    },
    {
      path: "services/advertise-your-business",
      element: <LAdvertiseYourBusiness />,
    },
    {
      path: "services/other-services-alt",
      element: <LOtherServices2 />,
    },
    {
      path: "memberships",
      element: <LMemberships />,
    },
    {
      path: "resources/recorded-clips",
      element: <LRecordedClips />,
    },
    {
      path: "resources/gallery",
      element: <LGallery />,
    },
    {
      path: "resources",
      element: <LLandingPage />,
    },
    {
      path: "memberships",
      element: <LLandingPage />,
    },
    {
      path: "faq",
      element: <LFAQ />,
    },
    {
      path: "services/other-services",
      element: <LOtherServices />,
    },
    {
      path: "member/resource-hub",
      element: <LResourceHub />,
    },
    {
      path: "terms-and-conditions",
      element: <LTermsAndConditions />,
    },
    {
      path: "products",
      element: <LCustomerProducts />,
    },
  ],
};

export const PaymentsRoutes = {
  path: "/",
  element: <GeneralLayoutAlt />,
  children: [
    {
      path: "abortions/payments/:paymentId",
      element: <LPaymentAbortion />,
    },
  ],
};

export default NoAuthRoutes;
